import { useState, useEffect, useRef } from 'react';

function useIdle(ms: number, cb: () => void) {
    const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const reset = () => {
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
        }
        timeoutIdRef.current = setTimeout(() => {
            cb();
        }, ms);
    };

    useEffect(() => {
        const events = [
            "mousemove",
            "keydown",
            "keyup",
            "scroll",
            "click",
            "touchstart",
            "input",
            "mousedown",
            "mouseup",
            "dragstart",
            "drag",
            "dragend",
            "dragover",
            "dragenter",
            "dragleave",
        ];

        for (const evt of events) {
            window.addEventListener(evt, reset, { passive: true });
        }

        reset();

        return () => {
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
            }
            for (const evt of events) {
                window.removeEventListener(evt, reset);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ms]);

}

export default useIdle;